import type { Column } from '@/types'
import type { Document } from '@/store/parser'
import { ref } from 'vue'
import { from, tap } from 'rxjs'
import { liveQuery } from 'dexie'
import { useObservable } from '@vueuse/rxjs'
import db from '@/plugins/database'
import type { DeckEvent } from '@/lib/events'

export const subscriptions = ref<Set<string>>(new Set())
export const documents = useObservable<Document[], []>(
  from(liveQuery(() => db.documents.toArray())),
  {
    initialValue: []
  }
)
export const events = useObservable<DeckEvent[], []>(
  from(liveQuery(() => db.events.toArray())),
  {
    initialValue: []
  }
)
export const columnsReady = ref(false)
export const columns = useObservable<Column[], []>(
  from(liveQuery(() => db.columns.orderBy('order').toArray())).pipe(
    tap(() => {
      columnsReady.value = true
    })
  ),
  {
    initialValue: []
  }
)
